import * as React from 'react';
import Accepted from '../assets/images/Accepted.svg';
import Attention from '../assets/images/Attention.svg';
import BackArrow from '../assets/images/BackArrow.svg';
import BecomeRyanCarrier from '../assets/images/BecomeRyanCarrier.svg';
import Booked from '../assets/images/Booked.svg';
import Cancel from '../assets/images/Cancel.svg';
import CancelRed from '../assets/images/CancelRed.svg';
import CapacityStars from '../assets/images/CapacityStars.svg';
import Check from '../assets/images/Check.svg';
import Clock from '../assets/images/Clock.svg';
import ClockLight from '../assets/images/ClockLight.svg';
import Close from '../assets/images/Close.svg';
import Delivery from '../assets/images/Delivery.svg';
import DollarOffMedium from '../assets/images/DollarOffMedium.svg';
import DollarOffMediumBlue from '../assets/images/DollarOffMediumBlue.svg';
import DollarSignDisabled from '../assets/images/DollarSignDisabled.svg';
import DollarSignEnabled from '../assets/images/DollarSignEnabled.svg';
import DownArrowBlack from '../assets/images/DownArrowBlack.svg';
import EditPencil from '../assets/images/EditPencil.svg';
import EditPencilDisabled from '../assets/images/EditPencilDisabled.svg';
import Email from '../assets/images/Email.svg';
import ExclamationPoint from '../assets/images/ExclamationPoint.svg';
import InfoCircle from '../assets/images/InfoCircle.svg';
import LanesEmptyStateMap from '../assets/images/LanesEmptyStateMap.svg';
import MapDelivery from '../assets/images/MapDelivery.svg';
import MapPickup from '../assets/images/MapPickup.svg';
import MapPin from '../assets/images/MapPin.svg';
import NotificationIllustration from '../assets/images/NotificationIllustration.svg';
import NotificationSettings from '../assets/images/NotificationSettings.svg';
import NotificationOff from '../assets/images/NotificationsOff.svg';
import NotificationOn from '../assets/images/NotificationsOn.svg';
import Phone from '../assets/images/Phone.svg';
import Pickup from '../assets/images/Pickup.svg';
import Plus from '../assets/images/Plus.svg';
import PlusBlue from '../assets/images/PlusBlue.svg';
import PlusOrange from '../assets/images/PlusOrange.svg';
import Price from '../assets/images/Price.svg';
import Refresh from '../assets/images/Refresh.svg';
import RefreshGrey from '../assets/images/RefreshGrey.svg';
import RightArrow from '../assets/images/RightArrow.svg';
import RightArrowBlack from '../assets/images/RightArrowBlack.svg';
import RightBigArrowBlack from '../assets/images/RightBigArrowBlack.svg';
import RightBigArrowBlue from '../assets/images/RightBigArrowBlue.svg';
import RightBigArrowDisabled from '../assets/images/RightBigArrowDisabled.svg';
import RowArrow from '../assets/images/RowArrow.svg';
import RtsProWhite from '../assets/images/RtsProWhite.svg';
import Save from '../assets/images/Save.svg';
import Search from '../assets/images/Search.svg';
import SignUp from '../assets/images/SignUp.svg';
import Snowflake from '../assets/images/Snowflake.svg';
import SuccessAnimation from '../assets/images/SuccessAnimation.gif';
import SuccessAnimationNoRepeat from '../assets/images/SuccessAnimationNoRepeat.gif';
import Tour from '../assets/images/Tour.svg';
import Trash from '../assets/images/Trash.svg';
import TrashBin from '../assets/images/TrashBin.svg';
import Verifying from '../assets/images/Verifying.svg';
import FreightAlert from '../assets/images/FreightAlert.svg';
import FreightBox from '../assets/images/FreightBox.svg';
import SendRight from '../assets/images/SendRight.svg';
import Glass from '../assets/images/Glass.svg';
import EmailCircle from '../assets/images/EmailCircle.svg';
import styled from '../theme';

export type ImageName =
  | 'RefreshGrey'
  | 'RtsProWhite'
  | 'Search'
  | 'Refresh'
  | 'Clock'
  | 'RowArrow'
  | 'Close'
  | 'Pickup'
  | 'Delivery'
  | 'Phone'
  | 'Email'
  | 'RightArrow'
  | 'RightArrowBlack'
  | 'Price'
  | 'SignUp'
  | 'MapPin'
  | 'BackArrow'
  | 'ClockLight'
  | 'Cancel'
  | 'Trash'
  | 'Save'
  | 'DownArrowBlack'
  | 'DollarSignDisabled'
  | 'DollarSignEnabled'
  | 'RightBigArrowBlack'
  | 'RightBigArrowBlue'
  | 'RightBigArrowDisabled'
  | 'Booked'
  | 'Accepted'
  | 'Verifying'
  | 'CancelRed'
  | 'Check'
  | 'BecomeRyanCarrier'
  | 'DollarOffMedium'
  | 'DollarOffMediumBlue'
  | 'NotificationOn'
  | 'NotificationOff'
  | 'Tour'
  | 'NotificationIllustration'
  | 'LanesEmptyStateMap'
  | 'CapacityStars'
  | 'NotificationSettings'
  | 'EditPencil'
  | 'EditPencilDisabled'
  | 'PlusBlue'
  | 'PlusOrange'
  | 'Plus'
  | 'InfoCircle'
  | 'TrashBin'
  | 'SuccessAnimation'
  | 'SuccessAnimationNoRepeat'
  | 'MapDelivery'
  | 'MapPickup'
  | 'Snowflake'
  | 'ExclamationPoint'
  | 'Attention'
  | 'FreightAlert'
  | 'FreightBox'
  | 'SendRight'
  | 'Glass'
  | 'EmailCircle';

const Images: { [key in ImageName]: string } = {
  RefreshGrey,
  RightArrow,
  RtsProWhite,
  Search,
  Refresh,
  Clock,
  RowArrow,
  Close,
  Pickup,
  Delivery,
  Phone,
  Email,
  RightArrowBlack,
  Price,
  SignUp,
  MapPin,
  BackArrow,
  ClockLight,
  Cancel,
  Trash,
  Save,
  DownArrowBlack,
  DollarSignDisabled,
  DollarSignEnabled,
  RightBigArrowBlack,
  RightBigArrowBlue,
  RightBigArrowDisabled,
  Booked,
  Accepted,
  Verifying,
  CancelRed,
  Check,
  BecomeRyanCarrier,
  DollarOffMedium,
  DollarOffMediumBlue,
  NotificationOn,
  NotificationOff,
  Tour,
  NotificationIllustration,
  LanesEmptyStateMap,
  CapacityStars,
  NotificationSettings,
  EditPencil,
  EditPencilDisabled,
  PlusBlue,
  PlusOrange,
  Plus,
  InfoCircle,
  TrashBin,
  SuccessAnimation,
  SuccessAnimationNoRepeat,
  MapDelivery,
  MapPickup,
  Snowflake,
  ExclamationPoint,
  Attention,
  FreightAlert,
  FreightBox,
  SendRight,
  Glass,
  EmailCircle,
};

interface Props {
  name: ImageName;
  alt: string;
  height?: number;
  width?: number;
  margin?: string;
  onClick?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
}

interface ImageStyledProps {
  height?: number;
  width?: number;
  margin?: string;
  onClick?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
}

const Image = styled.img<ImageStyledProps>`
  height: ${({ height }) => height && `${height}px`};
  width: ${({ width }) => width && `${width}px`};
  margin: ${({ margin }) => margin && `${margin}`};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};
`;

const Icon: React.FunctionComponent<Props> = ({ name, alt, ...rest }) => {
  return <Image {...rest} src={Images[name]} alt={alt} />;
};

export default Icon;
